export const getAltDescription = (product) => {
    let result = `Модель: ${product.model}; Бренд: ${typeof product.brand === "string" ? product.brand : product.brand.name}; `;
    product.altData &&
        Object.keys(product.altData).forEach((name) => {
            if (name === "materials") {
                const value = product.altData[name].length ? product.altData[name].join(", ") : "Не указано";
                result += `Материал: ${value}; `;
            }
            else if (name === "color") {
                result += `Цвет: ${product.altData[name] || "Не указано"}; `;
            }
            else if (name === "country") {
                result += `Страна производства: ${product.altData[name] || "Не указано"}`;
            }
        });
    return result;
};
